<div class=" " *ngIf="showRequest"  [class.read-only-content]="isReadOnly">
  <h2 class="sectionTitle" *ngIf="!isReadOnly">
    {{'FRONT_USER.Floating_Carnes_Request_Form.AddFloatingCarnesRequest' | translate }}</h2>


      <!--request Details summary-->
      <app-request-details *ngIf="requestId" [baseRequest]="baseRequestDTO"></app-request-details>
      <!--request -->


  <form [formGroup]="addFloatingCarnesRequestForm"  *ngIf="!showSuccessMessage">

    <div *ngIf="uploadResponse.status === 'progress'">
      <div role="progressbar" [style.width.%]="uploadResponse.message" aria-valuenow="25" aria-valuemin="0"
        aria-valuemax="100">
        {{uploadResponse.message}}%
      </div>
    </div>

    <fieldset id="textFieldSet" [disabled]="isReadOnly">
      <div class="form-container">
        <h4 class="section-title">{{ 'FRONT_USER.REQUEST_INFORMATION' | translate }}</h4>
        <!-- Nearest Location -->
        <div class="form-group">
          <label id="example-radio-group-label">{{'FRONT_USER.Floating_Carnes_Request_Form.NearestLocation'|translate}}</label>
          <span class="red"> *</span>
          <div class="form-custom-inputs">
            <div class="custom-Radio"  *ngFor="let location of nearestLocationKeys;let i='index'">
              <input [id]="[location]"  type="radio"  name="NearestLocation"  [value]="nearestLocation[location]"
                 formControlName="NearestLocation" />
              <label [for]="[location]">{{'FRONT_USER.REPAIR_REQUEST_FORM.' + location | translate }}</label>
            </div>
          </div>
          <div *ngIf="submitted && f.NearestLocation?.errors ||(f.NearestLocation?.errors&&f.NearestLocation?.dirty)"
            class="red ">
            <div *ngIf="f.NearestLocation?.errors?.required">
              {{'FRONT_USER.Floating_Carnes_Request_Form.ThisFieldIsRequired' | translate}}</div>
          </div>
        </div>

        <!-- Vessel Type -->
        <div class="form-group">
          <label for="VesselTypeId">{{'FRONT_USER.REPAIR_REQUEST_FORM.VESSEL_TYPE' | translate}}</label>
          <span class="red"> *</span>
          <select id="VesselTypeId" name="VesselTypeId" class="form-control" formControlName="VesselTypeId">
            <option [value]="null" selected>{{'FRONT_USER.REPAIR_REQUEST_FORM.CHOOSE_VESSEL_TYPE' | translate}}</option>
            <ng-container *ngFor="let vessel of vesselType">
              <option *ngIf="displayedLang=='NameEN'" [value]="vessel.Id">
                {{vessel.NameEN}}
              </option>
              <option *ngIf="displayedLang=='NameAR'" [value]="vessel.Id">
                {{vessel.NameAR}}
              </option>
            </ng-container>
          </select>
          <div *ngIf="(submitted || f.VesselTypeId?.touched) &&(f.VesselTypeId?.errors||f.VesselTypeId?.value=='null')"
            class="red ">
            <div *ngIf="f.VesselTypeId?.errors?.required|| f.VesselTypeId?.value=='null'">
              {{'FRONT_USER.Floating_Carnes_Request_Form.ThisFieldIsRequired' | translate}}
            </div>
          </div>
        </div>

        <!-- Max Outreach -->
        <div class="form-group">
          <label for="MaxOutreach">{{ 'FRONT_USER.Floating_Carnes_Request_Form.MaxOutreach' | translate}}</label>
          <span class="red"> *</span>
          <div class="split-form-group-units">
            <input type="text" class="form-control" id="maxOutreach" name="maxOutreach" formControlName="MaxOutreach">
            <select id="MaxOutreachUnit" name="MaxOutreachUnit" class="form-control" formControlName="MaxOutreachUnit">

              <option [value]="null" selected >{{'FRONT_USER.CHOOSE' | translate}} </option>
              <option *ngFor="let mesurement of mesurementUnitKeys"  [value]="mesurementUnit[mesurement]">{{mesurement}}
              </option>
            </select>
          </div>
          <div *ngIf="submitted && f.MaxOutreach?.errors ||(f.MaxOutreach?.errors&&f.MaxOutreach?.dirty)" class="red ">
            <div *ngIf="f.MaxOutreach?.errors?.required">
              {{'FRONT_USER.Floating_Carnes_Request_Form.ThisFieldIsRequired' | translate}}</div>
            <div *ngIf="f.MaxOutreach?.errors?.pattern">{{'FRONT_USER.NUMBER_ERROR' | translate}}</div>
          </div>
          <div *ngIf="(submitted ||f.MaxOutreachUnit?.touched) &&(f.MaxOutreachUnit?.errors||f.MaxOutreachUnit?.value=='null')"
            class="red ">
            <div *ngIf="f.MaxOutreachUnit?.errors?.required||f.MaxOutreachUnit?.value=='null'">{{'FRONT_USER.UNIT_Is_Required' | translate}}</div>
          </div>
        </div>

        <!-- Total Weight -->
        <div class="form-group">
          <label for="TotalWeight">{{ 'FRONT_USER.Floating_Carnes_Request_Form.TotalWeight' | translate}}</label>
          <span class="red"> *</span>
          <div class="input-group">
            <input type="text" class="form-control" id="totalWeight" name="totalWeight" formControlName="TotalWeight">
            <span class="input-group-addon">{{ 'FRONT_USER.REPAIR_REQUEST_FORM.TON' | translate}}</span>

          </div>
          <div *ngIf="submitted && f.TotalWeight?.errors ||(f.TotalWeight?.errors&&f.TotalWeight?.dirty)" class="red ">
            <div *ngIf="f.TotalWeight?.errors?.required">
              {{'FRONT_USER.Floating_Carnes_Request_Form.ThisFieldIsRequired' | translate}}</div>
            <div *ngIf="f.TotalWeight?.errors?.pattern">{{'FRONT_USER.NUMBER_ERROR' | translate}}</div>

          </div>
        </div>




        <!-- Estimated Hours To Done Request -->
        <div class="form-group">
          <label
            for="EstimatedHoursToDoneRequest">{{ 'FRONT_USER.Floating_Carnes_Request_Form.EstimatedHoursToDoneRequest' | translate}}</label>
          <span class="red"> *</span>
          <input type="text" class="form-control" id="estimatedHoursToDoneRequest" name="estimatedHoursToDoneRequest"
            formControlName="EstimatedHoursToDoneRequest">
          <div
            *ngIf="submitted && f.EstimatedHoursToDoneRequest?.errors ||(f.EstimatedHoursToDoneRequest?.errors&&f.EstimatedHoursToDoneRequest?.dirty)"
            class="red ">
            <div *ngIf="f.EstimatedHoursToDoneRequest?.errors?.required">
              {{'FRONT_USER.Floating_Carnes_Request_Form.ThisFieldIsRequired' | translate}}</div>
            <div *ngIf="f.EstimatedHoursToDoneRequest?.errors?.pattern">{{'FRONT_USER.NUMBER_ERROR' | translate}}</div>

          </div>
        </div>

        <div class="form-group">
          <label
            for="ExpectedRequestExecutingDate">{{ 'FRONT_USER.Floating_Carnes_Request_Form.ExpectedRequestExecutingDate' | translate}}</label>
          <span class="red"> *</span>
          <input class="form-control" #datepickerYMD="bsDatepicker" bsDatepicker
            formControlName="ExpectedRequestExecutingDate" [minDate]="dateToSelectRequestExecutingDate"
            [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY', containerClass : 'theme-dark-blue' }"
            [ngClass]="{ 'is-invalid': formSubmitted && agentForm.get('agentCertificate')?.get('ExpectedRequestExecutingDate')?.errors }">
          <div
            *ngIf="submitted && f.ExpectedRequestExecutingDate?.errors ||(f.ExpectedRequestExecutingDate?.errors&&f.ExpectedRequestExecutingDate?.dirty)"
            class="red ">
            <div *ngIf="f.ExpectedRequestExecutingDate?.errors?.required">
              {{'FRONT_USER.Floating_Carnes_Request_Form.ThisFieldIsRequired' | translate}}</div>
            <div *ngIf="f.ExpectedRequestExecutingDate?.errors?.inValidDateError">
              {{'FRONT_USER.DATE_ERROR' | translate}}</div>
            <div *ngIf="f.ExpectedRequestExecutingDate?.errors?.dateExceededNextTwoDaysError">
              {{'FRONT_USER.Floating_Carnes_Request_Form.DateMustStartFrom' | translate}}
              {{dateToSelectRequestExecutingDate | date: 'dd/MM/yyyy' }}</div>
          </div>
        </div>


        <!-- Description -->
        <div class="form-group">
          <label for="Description">{{ 'FRONT_USER.Floating_Carnes_Request_Form.Description' | translate}}</label>
          <span class="red"> *</span>
          <textarea rows="4" cols="50" class="form-control" id="description" name="description"
            formControlName="Description"></textarea>
          <div *ngIf="submitted && f.Description?.errors ||(f.Description?.errors&&f.Description?.dirty)" class="red ">
            <div *ngIf="f.Description?.errors?.required">
              {{'FRONT_USER.Floating_Carnes_Request_Form.ThisFieldIsRequired' | translate}}</div>
            <div *ngIf="f.Description?.errors?.maxlength">
              {{'FRONT_USER.REPAIR_REQUEST_FORM.WORK_DESCRIPTION_MAX_LENGTH_ERROR' | translate}}</div>
            <div *ngIf="f.Description?.errors?.startsWithSpaceError">{{'FRONT_USER.START_WITH_SPACE' | translate}}
            </div>
          </div>
        </div>

        <!-- supports From Customer -->
        <div class="form-group">
          <label
            for="supportsFromCustomer">{{ 'FRONT_USER.Floating_Carnes_Request_Form.SupportsFromCustomer' | translate}}</label>
            <span class="red"> *</span>
          <textarea class="form-control" id="supportsFromCustomer" name="supportsFromCustomer"
            formControlName="SupportsFromCustomer"></textarea>
          <div
            *ngIf="submitted && f.SupportsFromCustomer?.errors ||(f.SupportsFromCustomer?.errors&&f.SupportsFromCustomer?.dirty)"
            class="red ">
             <div *ngIf="f.SupportsFromCustomer?.errors?.required">
              {{'FRONT_USER.Floating_Carnes_Request_Form.ThisFieldIsRequired' | translate}}</div>
            <div *ngIf="f.SupportsFromCustomer?.errors?.maxlength">
              {{'FRONT_USER.REPAIR_REQUEST_FORM.WORK_DESCRIPTION_MAX_LENGTH_ERROR' | translate}}</div>
            <div *ngIf="f.SupportsFromCustomer?.errors?.startsWithSpaceError">
              {{'FRONT_USER.START_WITH_SPACE' | translate}}
            </div>
          </div>
        </div>

      </div>
    </fieldset>

    <fieldset id="filesInputsFieldSet" *ngIf="!isReadOnly">
      <div class="form-container">
        <h4 class="section-title">{{ 'FRONT_USER.Floating_Carnes_Request_Form.ATTACHMENTS' | translate}}</h4>
        <div class="form-group">
          <label for="ShipPhotoInput">{{ 'FRONT_USER.Floating_Carnes_Request_Form.ShipPhoto' | translate}}</label>
          <span class="red"> *</span>
          <input type="file" accept=".pdf,.bmp,.doc,.docx,.gif,.jpg,.jpeg,.png" MaxSizeInMB="5" class="form-control"
            id="ShipPhotoInput" formControlName="ShipPhotoInput"
            (change)="onFileSelected($event, f.ShipPhotoInput, 'FloatingCarnesRequest_Ship_Photo' , Attachment.ShipPhoto, 'ShipPhotoProgress','FRONT_USER.Floating_Carnes_Request_Form.ShipPhoto')" />
          <div class="upload-info">
            <span>{{'FRONT_USER.Floating_Carnes_Request_Form.AllowedFileExtentionsTitle' | translate}}</span>
            <span>{{'FRONT_USER.Floating_Carnes_Request_Form.MaxFileSizeTitle' | translate}}</span>
          </div>
          <div *ngIf="submitted && f.ShipPhotoInput?.errors ||(f.ShipPhotoInput?.errors&&f.ShipPhotoInput?.dirty)"
            class="red ">
            {{'FRONT_USER.Floating_Carnes_Request_Form.ThisFieldIsRequired' | translate}}

            <!-- <div *ngIf="f.ShipPhotoInput?.errors?.required">
              {{'FRONT_USER.Floating_Carnes_Request_Form.ThisFieldIsRequired' | translate}}</div> -->
          </div>
          <div class="progress">
            <div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"
              [style.width]="ShipPhotoProgress + '%'">
              <span class=""> {{ShipPhotoProgress}} % Complete</span>
            </div>
          </div>
        </div>
        <div class="form-group">
          <label for="ObjectToLiftPhotoInput">
            {{ 'FRONT_USER.Floating_Carnes_Request_Form.ObjectToLiftPhoto' | translate}}
            <span class="red" style="font-weight: 100; "> *</span>
          </label>

          <input type="file" accept=".pdf,.bmp,.doc,.docx,.gif,.jpg,.jpeg,.png" MaxSizeInMB="5" class="form-control"
            id="ObjectToLiftPhotoInput" formControlName="ObjectToLiftPhotoInput"
            (change)="onFileSelected($event, f.ObjectToLiftPhotoInput, 'FloatingCarnesRequest_Object_To_Lift_Photo', Attachment.ObjectToLiftPhoto, 'objectToLiftPhotoProgress', 'FRONT_USER.Floating_Carnes_Request_Form.ObjectToLiftPhoto')" />
          <div class="upload-info">
            <span>{{'FRONT_USER.Floating_Carnes_Request_Form.AllowedFileExtentionsTitle' | translate}}</span>
            <span>{{'FRONT_USER.Floating_Carnes_Request_Form.MaxFileSizeTitle' | translate}}</span>
          </div>
          <div
            *ngIf="submitted && f.ObjectToLiftPhotoInput?.errors ||(f.ObjectToLiftPhotoInput?.errors && f.ObjectToLiftPhotoInput?.dirty)"
            class="red ">
            {{'FRONT_USER.Floating_Carnes_Request_Form.ThisFieldIsRequired' | translate}}
            <!-- <div *ngIf="f.ObjectToLiftPhotoInput?.errors?.required">
              {{'FRONT_USER.Floating_Carnes_Request_Form.ThisFieldIsRequired' | translate}}</div> -->
          </div>
          <div class="progress">
            <div class="progress-bar" role="progressbar" aria-valuenow="70" aria-valuemin="0" aria-valuemax="100"
              [style.width]="objectToLiftPhotoProgress + '%'">
              <span class=""> {{objectToLiftPhotoProgress}} % Complete</span>
            </div>
          </div>
        </div>
      </div>
    </fieldset>

    <fieldset id="attachmentsUrls" *ngIf="isReadOnly">

      <div class="form-container">
        <h4 class="section-title">Attachements</h4>
        <div class="form-group">
          <label for="ShipPhotoInput">{{ 'FRONT_USER.Floating_Carnes_Request_Form.ShipPhoto' | translate}}</label>
          <a [attr.href]="shipPhotoAttachmentUrl" target="_blank">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="512pt">
              <g fill-rule="evenodd">
                <path
                  d="m441.367188 214.8125v-112.511719c0-.113281-.011719-.230469-.015626-.34375-.003906-.109375-.007812-.21875-.015624-.324219-.03125-.433593-.078126-.859374-.160157-1.28125-.085937-.425781-.207031-.84375-.34375-1.25-.035156-.105468-.074219-.203124-.109375-.304687-.144531-.386719-.308594-.765625-.496094-1.132813-.011718-.019531-.019531-.042968-.03125-.0625-.203124-.378906-.4375-.742187-.691406-1.097656-.0625-.089844-.128906-.179687-.195312-.269531-.269532-.347656-.554688-.6875-.867188-1.007813l-92.300781-92.296874c-.316406-.316407-.65625-.601563-1.007813-.867188-.089843-.070312-.175781-.136719-.265624-.199219-.355469-.25-.71875-.488281-1.101563-.6875-.019531-.015625-.042969-.023437-.0625-.035156-.367187-.1875-.742187-.351563-1.125-.492187-.105469-.039063-.207031-.078126-.3125-.113282-.40625-.136718-.820313-.257812-1.242187-.339844-.007813-.003906-.011719-.003906-.019532-.003906-.414062-.082031-.835937-.128906-1.261718-.1562498-.113282-.0078124-.222657-.015625-.335938-.0195312s-.222656-.015625-.335938-.015625h-258.441406c-5.523437 0-10 4.476562-10 10v204.8125c-21.902344 17.746094-43.960937 39.699219-68.183594 67.640625-3.261718 3.757813-3.261718 9.339844 0 13.101563 24.222657 27.941406 46.28125 49.890624 68.183594 67.640624v138.804688c0 5.523438 4.476563 10 10 10h350.738282c5.523437 0 10-4.476562 10-10v-138.808594c21.90625-17.746094 43.964843-39.695312 68.1875-67.640625 3.261718-3.757812 3.261718-9.339843 0-13.101562-24.222657-27.941407-46.28125-49.890625-68.1875-67.636719zm-92.296876-180.667969 58.15625 58.15625h-58.15625zm-258.441406-14.144531h238.441406v82.300781c0 5.519531 4.476563 10 10 10h82.296876v87.433594c-6.175782-4.3125-12.382813-8.339844-18.675782-12.113281-44.734375-26.824219-92.71875-39.863282-146.691406-39.863282s-101.957031 13.039063-146.691406 39.863282c-6.292969 3.773437-12.503906 7.804687-18.679688 12.113281zm291.207032 269.003906c0 66.832032-56.449219 121.207032-125.835938 121.207032s-125.835938-54.375-125.835938-121.207032c0-66.835937 56.449219-121.210937 125.835938-121.210937s125.835938 54.375 125.835938 121.210937zm-295.875 60.894532c-22.980469-18.222657-43.492188-39.1875-62.671876-60.894532 19.179688-21.710937 39.691407-42.675781 62.671876-60.898437.597656-.378907 1.160156-.816407 1.664062-1.308594 20.390625-15.96875 42.738281-29.753906 67.824219-39.980469-27.882813 25.734375-45.285157 62.03125-45.285157 102.1875 0 40.152344 17.398438 76.449219 45.28125 102.183594-25.082031-10.226562-47.429687-24.011719-67.820312-39.976562-.503906-.496094-1.066406-.933594-1.664062-1.3125zm335.40625 142.101562h-330.738282v-113.730469c6.175782 4.3125 12.386719 8.339844 18.679688 12.113281 44.734375 26.824219 92.71875 39.863282 146.691406 39.863282s101.957031-13.039063 146.691406-39.863282c6.292969-3.773437 12.5-7.800781 18.675782-12.113281zm4.671874-142.105469c-.601562.382813-1.164062.820313-1.667968 1.316407-20.394532 15.964843-42.734375 29.75-67.816406 39.976562 27.878906-25.738281 45.28125-62.03125 45.28125-102.1875s-17.402344-76.449219-45.285157-102.183594c25.085938 10.222656 47.429688 24.007813 67.820313 39.976563.507812.496093 1.066406.933593 1.667968 1.3125 22.980469 18.222656 43.488282 39.1875 62.671876 60.894531-19.179688 21.710938-39.6875 42.675781-62.671876 60.894531zm0 0">
                </path>
                <path
                  d="m188.808594 289.003906c0 35.972656 30.140625 65.242188 67.191406 65.242188s67.191406-29.269532 67.191406-65.242188c0-35.976562-30.140625-65.246094-67.191406-65.246094s-67.191406 29.269532-67.191406 65.246094zm114.382812 0c0 24.945313-21.171875 45.242188-47.191406 45.242188-26.023438 0-47.191406-20.296875-47.191406-45.242188 0-24.949218 21.167968-45.246094 47.191406-45.246094s47.191406 20.296876 47.191406 45.246094zm0 0">
                </path>
              </g>
            </svg>
            View File
          </a>
        </div>
        <div class="form-group">
          <label
            for="ObjectToLiftPhotoInput">{{ 'FRONT_USER.Floating_Carnes_Request_Form.ObjectToLiftPhoto' | translate}}</label>
          <a [attr.href]="ObjectToLiftPhotoAttachmentUrl" target="_blank">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="512pt">
              <g fill-rule="evenodd">
                <path
                  d="m441.367188 214.8125v-112.511719c0-.113281-.011719-.230469-.015626-.34375-.003906-.109375-.007812-.21875-.015624-.324219-.03125-.433593-.078126-.859374-.160157-1.28125-.085937-.425781-.207031-.84375-.34375-1.25-.035156-.105468-.074219-.203124-.109375-.304687-.144531-.386719-.308594-.765625-.496094-1.132813-.011718-.019531-.019531-.042968-.03125-.0625-.203124-.378906-.4375-.742187-.691406-1.097656-.0625-.089844-.128906-.179687-.195312-.269531-.269532-.347656-.554688-.6875-.867188-1.007813l-92.300781-92.296874c-.316406-.316407-.65625-.601563-1.007813-.867188-.089843-.070312-.175781-.136719-.265624-.199219-.355469-.25-.71875-.488281-1.101563-.6875-.019531-.015625-.042969-.023437-.0625-.035156-.367187-.1875-.742187-.351563-1.125-.492187-.105469-.039063-.207031-.078126-.3125-.113282-.40625-.136718-.820313-.257812-1.242187-.339844-.007813-.003906-.011719-.003906-.019532-.003906-.414062-.082031-.835937-.128906-1.261718-.1562498-.113282-.0078124-.222657-.015625-.335938-.0195312s-.222656-.015625-.335938-.015625h-258.441406c-5.523437 0-10 4.476562-10 10v204.8125c-21.902344 17.746094-43.960937 39.699219-68.183594 67.640625-3.261718 3.757813-3.261718 9.339844 0 13.101563 24.222657 27.941406 46.28125 49.890624 68.183594 67.640624v138.804688c0 5.523438 4.476563 10 10 10h350.738282c5.523437 0 10-4.476562 10-10v-138.808594c21.90625-17.746094 43.964843-39.695312 68.1875-67.640625 3.261718-3.757812 3.261718-9.339843 0-13.101562-24.222657-27.941407-46.28125-49.890625-68.1875-67.636719zm-92.296876-180.667969 58.15625 58.15625h-58.15625zm-258.441406-14.144531h238.441406v82.300781c0 5.519531 4.476563 10 10 10h82.296876v87.433594c-6.175782-4.3125-12.382813-8.339844-18.675782-12.113281-44.734375-26.824219-92.71875-39.863282-146.691406-39.863282s-101.957031 13.039063-146.691406 39.863282c-6.292969 3.773437-12.503906 7.804687-18.679688 12.113281zm291.207032 269.003906c0 66.832032-56.449219 121.207032-125.835938 121.207032s-125.835938-54.375-125.835938-121.207032c0-66.835937 56.449219-121.210937 125.835938-121.210937s125.835938 54.375 125.835938 121.210937zm-295.875 60.894532c-22.980469-18.222657-43.492188-39.1875-62.671876-60.894532 19.179688-21.710937 39.691407-42.675781 62.671876-60.898437.597656-.378907 1.160156-.816407 1.664062-1.308594 20.390625-15.96875 42.738281-29.753906 67.824219-39.980469-27.882813 25.734375-45.285157 62.03125-45.285157 102.1875 0 40.152344 17.398438 76.449219 45.28125 102.183594-25.082031-10.226562-47.429687-24.011719-67.820312-39.976562-.503906-.496094-1.066406-.933594-1.664062-1.3125zm335.40625 142.101562h-330.738282v-113.730469c6.175782 4.3125 12.386719 8.339844 18.679688 12.113281 44.734375 26.824219 92.71875 39.863282 146.691406 39.863282s101.957031-13.039063 146.691406-39.863282c6.292969-3.773437 12.5-7.800781 18.675782-12.113281zm4.671874-142.105469c-.601562.382813-1.164062.820313-1.667968 1.316407-20.394532 15.964843-42.734375 29.75-67.816406 39.976562 27.878906-25.738281 45.28125-62.03125 45.28125-102.1875s-17.402344-76.449219-45.285157-102.183594c25.085938 10.222656 47.429688 24.007813 67.820313 39.976563.507812.496093 1.066406.933593 1.667968 1.3125 22.980469 18.222656 43.488282 39.1875 62.671876 60.894531-19.179688 21.710938-39.6875 42.675781-62.671876 60.894531zm0 0">
                </path>
                <path
                  d="m188.808594 289.003906c0 35.972656 30.140625 65.242188 67.191406 65.242188s67.191406-29.269532 67.191406-65.242188c0-35.976562-30.140625-65.246094-67.191406-65.246094s-67.191406 29.269532-67.191406 65.246094zm114.382812 0c0 24.945313-21.171875 45.242188-47.191406 45.242188-26.023438 0-47.191406-20.296875-47.191406-45.242188 0-24.949218 21.167968-45.246094 47.191406-45.246094s47.191406 20.296876 47.191406 45.246094zm0 0">
                </path>
              </g>
            </svg>
            View File
          </a>
        </div>
      </div>
    </fieldset>

    <app-user-request-details [UserRequestDetailsformGroup]="addFloatingCarnesRequestForm" [IsReadOnly]="isReadOnly"
      [SubmitFlag]="submitted" [extrnalData]="userInfo"></app-user-request-details>



    <div class="form-group" *ngIf="!isReadOnly">
      <label for="TermsAndConditions">{{ 'FRONT_USER.SALVAGE_REQUEST_FORM.TERMS_CONDITIONS' | translate }}</label>
      <span class="red"> *</span>
      <div class="custom-checkbox">
        <input type="checkbox" class="form-control" id="TermsAndConditions" name="TermsAndConditions"
          formControlName="TermsAndConditions" />
        <label
          for="TermsAndConditions">
          <a (click)="goToTermsAndConditions()" target="_blank" > {{ 'FRONT_USER.SALVAGE_REQUEST_FORM.TERMS_CONDITIONS_Acceptence' | translate }}</a>
        </label>
      </div>
      <div *ngIf="submitted && f.TermsAndConditions?.errors" class="red ">
        <div *ngIf="f.TermsAndConditions?.errors?.required">
          {{ 'FRONT_USER.Floating_Carnes_Request_Form.Accpet_TermsAndConditions_Error_Message' | translate | translate }}
        </div>
      </div>

    </div>

    <div class="form-group" *ngIf="!isReadOnly">
      <button Confirmation (confirmationClick)="onSubmit()" [disabled]="loading" class="btn btn-primary SCAcustomBtn">{{ 'FRONT_USER.SAVE' | translate}}</button>
    </div>
  </form>

</div>

<!-- <app-messaging *ngIf="requestId"></app-messaging> -->

<!-- Confirmation -->
<div *ngIf="!showRequest&&!isErrorMessage" class="alert alert-success" role="alert">
  <div class="alignC">
    <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve"
      xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g>
        <g>
          <path
            d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z">
          </path>
        </g>
      </g>
    </svg>
    <p> {{ 'FRONT_USER.SUCCESS_MESSAGE' | translate }}
    </p>
    <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/workspace"> {{ 'FRONT_USER.WORKSPACE.MY_WORKSPACE' | translate }}</a></p>
  </div>
</div>

<!-- error message -->
<div *ngIf="!showRequest&&isErrorMessage" class="alert alert-danger" role="alert">
    <div class="alignC">
        <i class="icon-error"></i>
        <p>{{'FRONT_USER.ERRORS_MESSAGES.ERROR' | translate}}</p>
        <p>{{'FRONT_USER.ERRORS_MESSAGES.EROOR_MESSAGE' | translate}}</p>

    </div>
</div>

<div *ngIf="requestId">
  <app-messaging></app-messaging>
</div>
